import { showError } from './showError';

export const login = async (email, password) => {
  try {
    if (!email || !password) {
      showError('Email or password is missing');
      return;
    }

    const res = await axios({
      method: 'POST',
      url: '/api/v1/users/login',
      data: {
        email,
        password,
      },
    });

    if (res.data.status === 'success')
      window.setTimeout(() => location.assign('/'), 1500);
  } catch (error) {
    showError(error.response.data.message);
  }
};

export const signUp = async (detailObj) => {
  try {
    const { name, email, phoneNo, password, passwordConfirm } = detailObj;
    if (!name || !email || !phoneNo || !password || !passwordConfirm) {
      showError('SignUp credentials missing');
      return;
    }
    const res = await axios({
      method: 'POST',
      url: '/api/v1/users/signup',
      data: {
        name,
        email,
        phoneNo,
        password,
        passwordConfirm,
      },
    });
    if (res.data.status === 'success')
      window.setTimeout(() => location.assign('/'), 1500);
  } catch (error) {
    const errorMsg = error.response.data.message;
    if (errorMsg.includes('password'))
      showError('Create stronger password (must contain 8 letters)');
    else showError('Invalid Signup credentials');
  }
};

export const forgotPasswordSend = async (email) => {
  try {
    if (!email) {
      showError('Please provide registered email');
      return;
    }
    const res = await axios({
      method: 'POST',
      url: `/api/v1/users/forgot-password`,
      data: {
        email,
      },
    });

    if (res.data.status === 'success') {
      alert(res.data.message);
      window.setTimeout(() => location.assign('/login'), 1500);
    }
  } catch (error) {
    showError(error.response.data.message);
  }
};

export const resetPasswordSend = async (token, password, passwordConfirm) => {
  try {
    const res = await axios({
      method: 'POST',
      url: `/api/v1/users/reset-password/${token}`,
      data: {
        password,
        passwordConfirm,
      },
    });

    if (res.data.status === 'success') {
      alert('Password Changed Successfully');
      window.setTimeout(() => location.assign('/login'), 1500);
    }
  } catch (error) {
    showError(error.response.data.message);
  }
};

export const createProductSend = async (formData) => {
  try {
    const res = await axios({
      method: 'POST',
      url: `/api/v1/products`,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    if (res.data.status === 'success') {
      alert('Product Added Successfully');
      window.setTimeout(
        () => location.assign(`/products/${formData.get('category')}`),
        1500,
      );
    }
  } catch (error) {
    showError(error.response.data.message, '0');
  }
};

export const postReview = async (review) => {
  if (!review) {
    showError('Review cannot be empty');
    return;
  }
  try {
    const res = await axios({
      method: 'POST',
      url: `/api/v1/products/${review.product}/reviews`,
      data: {
        review: review.text,
        rating: review.rating,
      },
    });
    if (res.data.status === 'success')
      window.setTimeout(
        () => location.assign(`/product/${review.product}`),
        1500,
      );
  } catch (error) {
    showError('Invalid Review Details', '0');
  }
};

export const updateDetails = async (detObj) => {
  try {
    const res = await axios({
      method: 'PATCH',
      url: `/api/v1/users/updatePhoneEmail`,
      data: {
        email: detObj.email,
        phoneNo: detObj.phoneNo,
      },
    });
    if (res.data.status === 'success')
      window.setTimeout(() => location.assign(`/account`), 1500);
  } catch (error) {
    showError('Please Update Valid Credentials', '0px');
  }
};
